export enum AvailableLocationsFilters {
  locationAddress = 'locationAddress',
  orgId = 'orgId',
}
